import React, { useEffect } from 'react'
import { TrustPortalAccessGrant } from '@trustero/trustero-api-web/lib/trust/trust_pb'
import { createContext, useContext, useState } from 'react'
import { ResourcePreviewTabs } from '../TrustApp.constants'

export type PublicTrustAccountContextType = {
  trustAccountId?: string
  trustPath?: string
  accessGrant?: TrustPortalAccessGrant | null
  setAccessGrant: (
    accessGrant: TrustPortalAccessGrant | undefined | null,
  ) => void
  activePreviewTab: ResourcePreviewTabs | null
  setActivePreviewTab: (tab: ResourcePreviewTabs) => void
}

export const PublicTrustAccountContext =
  createContext<PublicTrustAccountContextType>({
    trustAccountId: '',
    trustPath: '',
    accessGrant: undefined,
    setAccessGrant: () => null,
    activePreviewTab: null,
    setActivePreviewTab: () => null,
  })

export const usePublicTrustAccount = (): PublicTrustAccountContextType =>
  useContext(PublicTrustAccountContext)

export const PublicTrustAccountProvider = ({
  children,
  trustAccountId,
  trustPath,
}: {
  children: JSX.Element
  trustAccountId: string
  trustPath?: string
}): JSX.Element => {
  const [accessGrant, setAccessGrant] = useState<
    TrustPortalAccessGrant | undefined | null
  >(undefined)
  const [activePreviewTab, setActivePreviewTab] =
    useState<ResourcePreviewTabs | null>(null)

  useEffect(() => {
    if (accessGrant?.getIsAdmin() && activePreviewTab === null) {
      setActivePreviewTab(ResourcePreviewTabs.PUBLIC)
    }
  }, [accessGrant, activePreviewTab, setActivePreviewTab])

  return (
    <PublicTrustAccountContext.Provider
      value={{
        trustAccountId,
        trustPath,
        accessGrant,
        setAccessGrant,
        activePreviewTab,
        setActivePreviewTab,
      }}
    >
      {children}
    </PublicTrustAccountContext.Provider>
  )
}
